module.exports = __webpack_public_path__ + "static/img/rcg_right.583afd5.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/rcg_right.png
// module id = 2CVo
// module chunks = 0